<template>
  <div class="search-result">
    <NuxtLink :to="result.path.alias" class="search-result__inner">
      <div class="search-result__category">
        {{ useSearchItemTranslation(result.entityBundle) }}
      </div>
      <h2 class="search-result__heading">
        {{ result.label }}
      </h2>
      <div class="search result__description">
        {{ date }} {{ `${(result.text && text.length) ? text : ''}` }}
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  result: any
}>()

const text = computed(() => {
  return useStripHTML(props.result.text)
})

const date = computed(() => {
  if (props.result.date !== undefined) {
    if (props.result.date.start) {
      return useFormatDate('fullDate', props.result.date.start) + ' …'
    }
    if (props.result.date.value) {
      return useFormatDate('fullDate', props.result.date.value) + ' …'
    }
  }
})

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.search-result {
  &__inner {
    display: flex;
    flex-direction: column;
    gap: var(--grid-gutter);
    text-decoration: none;
  }

  &__category {
    @include tools.typo-heading-medium;
  }

  &__heading {
    margin: 0;
  }
}
</style>
